/*
	'Documentação'
	-------------------

	Esse container possui os seguintes componentes da listagem:
		- Table
		- Search
		- Modal de cadastrar
		- Toaster
		- Pesquisa avançada

	Basta chamar na página em que você deseja o 'ListagemContainer' e passar as seguintes props:

		# SERVICES
		- servicePaginacao (serviço da páginação com o metódo, ex: cadastrarDoacoes.findAll)
		- serviceSearch (serviço do search com o metódo, ex: cadastrarDoacoes.findAll)
		- serviceCadastrar (serviço do cadastrar com o metódo, ex: cadastrarDoacoes.findAll)
		- exportToCsv (serviço para exportar os registros da tabela em um arquico em formato csv)

		# TABELA
		- columns (colunas da tabela)
		- actions (actions da tabela)

		# TITULOS
		- listaTitle (titulo da lista)
		- pesquisaTitle (titulo da pesquisa)

		# BUTTONS
		- acoesSingleButton (botão de ação será single(true) ou um select(false))
		- titleButtonCadastrar (nome do botão de cadastrar item, se for omitido,
			o botão não será exibido)
		- titleButtonExportar (nome do botão para exportar rregistros em formato csv, se for omitido,
			o botão não será exibido)

		# MENSAGENS
		- emptyMessage (mensagem que será exibida caso não haja nenhum item cadastrado)
		- toastMessage (mensagem exibida no Toast de sucesso)

		# COMPONENTS

		- ComponenteCadastrar (componente usado na modal de cadastrar)

		- isPesquisaAvancada (variável booleana que indica se há pesquisa avançada no componente)

		- pesquisaAvancada (booleano que indica se o estado atual da pesquisa é
							avançado (true) ou simplificado (false).
							A variável de controle fica no componente pai e não no ListagemContainer
							e, portanto, é passada via Prop).

		- handlePesquisaAvancada (função responsável por alterar o state
									do componente pai do ListagemContainer
									e definir a variável de controle de pesquisaAvancada para true.
									É necessário passar essa função via Prop para que o ListagemContainer
									possa exibir a pesquisa avançada).

		- PesquisaAvancadaContext.Consumer (deve retornar o componente
											de pesquisa avançada a ser renderizado com suas respectivas Props).


		# Parâmetros essênciais para o funcionamento da ordenação

			- isOrderByGrid (variável booleana que ativa/desativa função de ordenação no Grid)

			- ordenar (parâmetro responsável por informar qual coluna da entidade listada vai ser ordenada
						Exemplo: 'status.codigo' ordena o status de uma entidade)

			- orderIcon (variável responsável por fazer o controle de direção da ordenação)

	Se quiser adicionar novas props, ou adicionar novos componentes, atualize a 'documentação'
*/

import Can from "components/Can/Can";
import { saveAs } from "file-saver";
import React, { Component } from "react";
import Button from "../../../components/Button/button.component";
import Searchbar from "../../../components/SearchBar/searchbar.component";
import Subtitle from "../../../components/Subtitle/subtitle.component";
import Table from "../../../components/Table/table.component";
import ExportaService from "../../../services/exportaService";
import ToastHelper from "../../../utils/toastHelper";

export const PesquisaAvancadaContext = React.createContext({
	errors: null,
	touched: null,
	values: null,
	handleChange: null,
	setFieldValue: null,
	resetForm: null
});

export default class ListagemContainer extends Component {
	state = {
		search: null,
		pagina: 0,
		pageContent: {},
		totalPages: 0,
		indicePagina: 0,
		isOpenCadastrar: false,
		totalElements: 0,
		totalItemPages: [],
		ordemDirecao: undefined,
		ordem: undefined,
		pesquisaAnterior: ""
	};

	componentDidMount() {
		this.exportaCSV = this.exportaCSV.bind(this);
		this.initialize();
	}

	/*
		MODAL CADASTRAR
	*/
	handleOpenModalCadastrar = () => {
		this.setState({ isOpenCadastrar: true });
	};

	handleCloseCadastrar = () => {
		this.setState({ isOpenCadastrar: false });
	};

	handleSalvarCadastrar = async values => {
		const { serviceCadastrar, toastMessage } = this.props;
		await serviceCadastrar(values);
		ToastHelper.success(toastMessage);
		this.initialize();
	};

	createModalCadastrar = ({ isOpenCadastrar }, { ComponenteCadastrar }) =>
		isOpenCadastrar && (
			<ComponenteCadastrar
				isOpenCadastrar={isOpenCadastrar}
				handleCloseCadastrar={this.handleCloseCadastrar}
				handleSalvarCadastrar={this.handleSalvarCadastrar}
			/>
		);

	/*
		Formata data no padrão dd-mm-yyyy hh:mm
	*/
	formataDataParaExportacao = () => {
		let formataData = new Date();

		const dia = String(formataData.getDate()).padStart(2, "0");
		const mes = String(formataData.getMonth() + 1).padStart(2, "0");
		const ano = formataData.getFullYear();

		const hora = String(formataData.getHours()).padStart(2, "0");
		const minuto = String(formataData.getMinutes()).padStart(2, "0");
		formataData = `${dia}-${mes}-${ano} ${hora}-${minuto}`;

		return formataData;
	};

	/*
		PAGINAÇÃO
	*/
	handlePaginacao = paginaValue => {
		const { servicePaginacao, pesquisaAvancada, filtroPadrao } = this.props;
		const { search, ordem, ordemDirecao } = this.state;

		this.setState({
			pesquisaAnterior: search || null
		});
		let filtro = {
			pagina: paginaValue,
			ordemDirecao: ordemDirecao || undefined,
			ordem
		};
		if (filtroPadrao) {
			filtro = {
				...filtro,
				...filtroPadrao
			};
		}

		if (!pesquisaAvancada) {
			filtro = { ...filtro, pesquisaSimples: search };
		} else {
			filtro = { ...filtro, ...pesquisaAvancada };
		}

		servicePaginacao(filtro).then(response => {
			this.setState({
				pageContent: response.data,
				showPages: response.data.totalPages,
				totalPages: response.data.totalPages,
				indicePagina: response.data.number,
				totalElements: response.data.totalElements,
				totalItemPages: response.data.content
			});
		});
	};

	/*
		PESQUISA
	*/
	handleChangeSearchInput = e => {
		this.setState({
			search: e.target.value
		});
	};

	handleSearch = () => {
		const {
			props: { serviceSearch, filtroPadrao },
			state: { search, ordemDirecao, ordem, pagina }
		} = this;

		const filtro = {
			...filtroPadrao,
			pesquisaSimples: search != null ? search : "",
			simplificado: true,
			ordemDirecao,
			ordem,
			pagina
		};

		serviceSearch(filtro).then(response => {
			this.setState({
				pesquisaAnterior: search || null,
				pageContent: response.data,
				showPages: response.data.totalPages,
				totalPages: response.data.totalPages,
				indicePagina: response.data.number,
				totalElements: response.data.totalElements,
				totalItemPages: response.data.content
			});
		});
	};

	handleSearchByOrder = (ordem, iniciaASC) => {
		const {
			props: {
				serviceSearch,
				pesquisaAvancada,
				isOrderByGrid,
				filtroPadrao
			},
			state: { search, ordemDirecao, indicePagina }
		} = this;

		let filtro = { ...filtroPadrao };

		if (!pesquisaAvancada) {
			filtro.pesquisaSimples = search;
		} else {
			filtro = { ...filtro, ...pesquisaAvancada };
		}

		if (isOrderByGrid) {
			filtro.pagina = indicePagina;
			if (!ordemDirecao && iniciaASC) {
				filtro.ordemDirecao = "ASC";
			} else if (!ordemDirecao || ordemDirecao === "ASC") {
				filtro.ordemDirecao = "DESC";
			} else if (ordemDirecao === "DESC") {
				filtro.ordemDirecao = "ASC";
			}
		}

		this.setState({ ordemDirecao: filtro.ordemDirecao, ordem });

		filtro.ordem = ordem;

		serviceSearch(filtro).then(response => {
			this.setState({
				pageContent: response.data,
				showPages: response.data.totalPages,
				totalPages: response.data.totalPages,
				indicePagina: response.data.number,
				totalElements: response.data.totalElements,
				totalItemPages: response.data.content
			});
		});

		return filtro.ordemDirecao;
	};

	manualSearch = (serviceSearch, values) => {
		const { ordem, ordemDirecao } = this.state;
		const { filtroPadrao } = this.props;

		const filtro = {
			...values,
			...filtroPadrao
		};
		if (ordem) {
			filtro.ordem = ordem;
			filtro.ordemDirecao = ordemDirecao;
		}

		if (values.isClearable) {
			filtro.ordem = "";
			filtro.ordemDirecao = undefined;
			filtro.isClearable = false;
		}

		serviceSearch(filtro).then(response => {
			this.setState({
				pageContent: response.data,
				showPages: response.data.totalPages,
				totalPages: response.data.totalPages,
				indicePagina: response.data.number,
				totalElements: response.data.totalElements,
				totalItemPages: response.data.content
			});
		});
	};

	handleKeyPress = event => {
		if (event.key === "Enter") {
			event.preventDefault();
			this.handleSearch();
		}
	};

	/* Exportar CSV */
	async exportaCSV() {
		const {
			state: { pesquisaAnterior },
			props: { pesquisaAvancada }
		} = this;

		const dataDownload = this.formataDataParaExportacao();

		/*
			Esse funciona para buscar o termo, de quando o usuário aperto o enter ou fez pesquisa.
			Por exemplo, caso o usuário digite "maré", mas não aperte o enter,
			será buscado o valor anterior, nesse caso "",
			ou seja, trará todos alertas. Caso ele aperte o enter, será buscado "maré",
			e caso ele digite "erosão", mas não faça a pesquisa, e exporte os valores,
			será exportado os alertas com categoria "maré" e não "erosão".

			Primeira condicional, serve para saber se já foi feita alguma pesquisa,
			isPesquisa é false por default, então sempre entrará, caso não tenha sido feita pesquisas.
			Segunda condicional serve para fazer buscas caso
			não tenha sido pesquisado vazio no campo pesquisa, nesse caso trará todos alertas

			Nos demais casos, fará exportação usando o search,
			em que sempre é buscado o valor que foi DIGITADO E PESQUISADO,
			não só DIGITADO.
		*/
		const filtro =
			pesquisaAvancada !== false
				? pesquisaAvancada
				: {
						pesquisaSimples: pesquisaAnterior || null
				  };
		const response = await ExportaService.exportToCsv(filtro);
		saveAs(response.data, `Expectativa de alerta ${dataDownload}.csv`);
	}

	/* filtro */
	createPesquisaAvancada(isPesquisaAvancada, children) {
		const { pesquisaAvancada } = this.props;
		return (
			isPesquisaAvancada &&
			pesquisaAvancada && (
				<React.Fragment>
					<PesquisaAvancadaContext.Provider>
						{children}
					</PesquisaAvancadaContext.Provider>
				</React.Fragment>
			)
		);
	}

	limpaCampoPesquisaSimplificada() {
		this.setState({ search: "" });

		const { servicePaginacao, filtroPadrao } = this.props;

		const filtro = {
			pagina: 0,
			...filtroPadrao
		};

		servicePaginacao(filtro).then(response => {
			this.setState({
				pageContent: response.data,
				showPages: response.data.totalPages,
				totalPages: response.data.totalPages,
				indicePagina: response.data.number,
				totalElements: response.data.totalElements,
				totalItemPages: response.data.content
			});
		});
	}

	pesquisaSimplificada(search, searchPlaceHolder, isFiltroAvancado) {
		const { pesquisaAvancada, handlePesquisaAvancada } = this.props;
		return (
			!pesquisaAvancada && (
				<div>
					<div>
						<Searchbar
							value={search}
							onClick={this.handleSearch}
							onKeyPress={this.handleKeyPress}
							onChange={this.handleChangeSearchInput}
							placeholder={searchPlaceHolder}
						/>
					</div>
					{isFiltroAvancado && !pesquisaAvancada && (
						<div className="mt-2">
							<button
								type="button"
								onClick={() => {
									handlePesquisaAvancada();
									this.limpaCampoPesquisaSimplificada();
								}}
								className="btn btn-link pl-0"
							>
								Pesquisa avançada
							</button>
						</div>
					)}
				</div>
			)
		);
	}

	initialize() {
		this.setState({ isOpenCadastrar: false });
		this.handlePaginacao(0);
	}

	/*
		Usado no visualizar, já que a entidade e oficio possui o botão de visualizar,
		então checa se é entidade ou oficio, se for, seta o botão para unico e mostra
		apenas a action de visualizar, caso seja a permissão
	*/
	checkActions = actions => {
		const { entidade, oficio } = this.props;
		if (entidade || oficio) {
			return [actions[0]];
		}
		return null;
	};

	checkActionsButton = () => {
		const { entidade, oficio } = this.props;
		if (entidade || oficio) {
			return true;
		}
		return false;
	};

	render() {
		const {
			props: {
				columns,
				actions,
				listaTitle,
				pesquisaTitle,
				acoesSingleButton,
				titleButtonCadastrar,
				titleButtonExportar,
				emptyMessage,
				searchPlaceHolder,
				trClass,
				isPesquisaAvancada,
				children,
				filtro,
				ordenar,
				isOrderByGrid,
				orderIcon,
				inititalOrderIcon,
				handleCadatroPage,
				permission,
				permissionCadastrar
			},
			state: {
				pageContent,
				totalPages,
				indicePagina,
				search,
				totalElements,
				totalItemPages
			}
		} = this;

		if (orderIcon && !orderIcon.icon && inititalOrderIcon) {
			orderIcon.nomeColuna = inititalOrderIcon.colunaTable;
			orderIcon.icon = inititalOrderIcon.iconOrderDirection;
		}

		return (
			<React.Fragment>
				<div className="card">
					<div className="card-body">
						<span className="card-title">
							<Subtitle nopadding="true">
								{pesquisaTitle}
							</Subtitle>
						</span>
						{isPesquisaAvancada &&
							this.createPesquisaAvancada(
								isPesquisaAvancada,
								children,
								filtro
							)}
						{this.pesquisaSimplificada(
							search,
							searchPlaceHolder,
							isPesquisaAvancada
						)}
					</div>
				</div>

				<div className="card mt-5 table-responsive">
					<div className="container d-flex justify-content-between mt-3">
						<div>
							<Subtitle nopadding="true">{listaTitle}</Subtitle>
						</div>
						<div className="d-flex justify-content-end">
							{titleButtonExportar && (
								<Can
									perform={permission}
									yes={() => (
										<div className="ml-auto">
											<Button
												title="Exporta todos alertas para o formato CSV"
												type="button"
												primary
												icon="fas fa-file-csv fa-md"
												text={titleButtonExportar}
												onClick={this.exportaCSV}
											/>
										</div>
									)}
									no={() => null}
								/>
							)}
							{titleButtonCadastrar && (
								<Can
									perform={permissionCadastrar}
									yes={() => (
										<div className="ml-auto">
											<Button
												type="button"
												primary
												icon="fas fa-plus"
												text={titleButtonCadastrar}
												onClick={
													handleCadatroPage ||
													this
														.handleOpenModalCadastrar
												}
											/>
										</div>
									)}
									no={() => null}
								/>
							)}
						</div>
					</div>

					<div className="card-body">
						<Table
							align="left"
							showPaginate
							totalElements={totalElements}
							columns={columns}
							actions={actions}
							data={pageContent.content || []}
							totalPages={totalPages}
							currentPage={indicePagina}
							totalItemPages={totalItemPages.length}
							onChangePage={page => this.handlePaginacao(page)}
							emptyMessage={emptyMessage}
							emptyColSpan={columns.length + 1}
							acoesSingleButton={acoesSingleButton}
							trClass={trClass}
							ordenar={ordenar}
							isOrderByGrid={isOrderByGrid}
							orderIcon={orderIcon}
							permission={permission}
						/>
					</div>
					{this.createModalCadastrar(this.state, this.props)}
				</div>
			</React.Fragment>
		);
	}
}
